import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	/* Popover,  */ Snackbar,
	Tabs,
	Tab,
	AppBar,
	Hidden,
	FormControl,
	RadioGroup,
	FormControlLabel,
	Radio,
} from '@material-ui/core'
import { FileCopy } from '@material-ui/icons'
import Button from 'components/theme/Button'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
	FORM_URL,
	CUSTOM_INTEGRATION_URL,
	CUSTOM_INTEGRATION_JSON_URL,
} from 'utils/AllURLs'
import language from 'utils/vast-languagepack'
import { Link } from 'react-router-dom'
import { listPreferences } from 'actions/AccountSettings'
import AceEditor from 'react-ace'
import pretty from 'pretty'
import 'brace/mode/javascript'
import 'brace/mode/python'
import 'brace/mode/php'
import 'brace/mode/sh'
import 'brace/theme/monokai'
import jsCode from './javascript'
import python from './python'
import php from './php'
import curl from './curl'

export default withRouter(
	connect(
		(state) => ({
			formID: state.signupForm.addOrEdit.formID,
			preferences: state.AccountSettings.preferences,
			formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
			internal_type: state.customForm?.addOrEdit?.internal_type,
		}),
		(dispatch) => bindActionCreators({ listPreferences }, dispatch),
	)(
		class EmbedCode extends Component {
			state = {
				copied: false,
				anchorEl: null,
				tabValue: 0,
				value: 'urlencoded',
			}

			componentDidMount() {
				this.props.listPreferences()
			}

			handleClick = (event) => {
				this.setState({ ...this.state, anchorEl: event.currentTarget })
			}

			handleClose = (event, reason) => {
				if (
					reason === 'clickaway' ||
					reason === 'backdropClick' ||
					reason === 'timeout'
				) {
					this.setState({ ...this.state, anchorEl: null, copied: false })
				}
			}

			handleTabChange = (event, tabValue) => {
				this.setState({ tabValue })
			}

			handleChange = (event) => {
				this.setState({ value: event.target.value })
			}

			render() {
				const disabled =
					!this.props.preferences.recaptcha_byo_secretkey ||
					!this.props.preferences.recaptcha_byo_sitekey

				const url =
					this.props.internal_type === 'ci1'
						? this.state.value === 'json'
							? `${CUSTOM_INTEGRATION_JSON_URL}/${this.props.formID}`
							: `${CUSTOM_INTEGRATION_URL}/${this.props.formID}`
						: `${FORM_URL}/${
								this.props.formTypeSelected === 'custom' ? 'custom/' : ''
						  }${this.props.formID}`

				const correctedFormID =
					this.props?.formID?.slice?.(0, 1) === '/'
						? this.props?.formID?.slice?.(1)
						: this.props?.formID

				const codeArr = [
					jsCode(correctedFormID, this.state.value),
					python(correctedFormID, this.state.value),
					curl(correctedFormID, this.state.value),
					php(correctedFormID, this.state.value),
				]

				const modeArr = ['javascript', 'python', 'sh', 'php']

				return (
          <div>
            {disabled && this.props.internal_type !== 'ci1' ? (
              <div
                style={{
                  backgroundColor: '#d5922b',
                  color: '#fff',
                  borderRadius: 35,
                  padding: 12,
                  fontSize: 18,
                }}
              >
                You are missing your recaptcha secret key and/or site key. In
                order to embed it, please add your key{' '}
                <Link to="/accountsettings">here</Link>. You can still directly
                link to this form.
              </div>
            ) : null}
            <div style={{ padding: '20px 10px 20px 20px' }}>
              {this.props.internal_type !== 'ci1' && (
                <>
                  <h3>{language.signupform.add.embedOnSite}</h3>
                  <input
                    style={{
                      // width: 450,
                      height: 35,
                      marginRight: 15,
                      // maxWidth: '100%',
                      width: 'calc(100% - 133px)',
                      borderRadius: 35,
                    }}
                    disabled={true}
                    value={`<div class="vast_reach${
                      this.props.formTypeSelected === 'custom' ? '_custom' : ''
                    }_form" data-vast-form-id="${
                      this.props.formID
                    }"></div><script src="${FORM_URL}/scripts/form_finder.js"></script>`}
                  />
                  <CopyToClipboard
                    onCopy={() =>
                      this.setState({
                        ...this.state,
                        copied: true,
                        open: true,
                        anchorEl: null,
                      })
                    }
                    text={`<div class="vast_reach${
                      this.props.formTypeSelected === 'custom' ? '_custom' : ''
                    }_form" data-vast-form-id="${
                      this.props.formID
                    }"></div><script src="${FORM_URL}/scripts/form_finder.js"></script>`}
                  >
                    <Button
                      size={'large'}
                      variant="contained"
                      color="secondary"
                      style={{ marginTop: 10 }}
                    >
                      <FileCopy style={{ marginRight: 5 }} />
                      Copy
                    </Button>
                  </CopyToClipboard>
                </>
              )}
              {this.props.internal_type === 'ci1' && (
                <div style={{ textAlign: 'center' }}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="datatype"
                      name="datatype"
                      value={this.state.value}
                      onChange={this.handleChange}
                      row
                    >
                      <FormControlLabel
                        value="urlencoded"
                        control={<Radio color="primary" />}
                        label="x-www-form-urlencoded"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="json"
                        control={<Radio color="primary" />}
                        label="JSON"
                        labelPlacement="end"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              )}
              <h3>
                {this.props.internal_type === 'ci1'
                  ? 'Here’s the webhook URL. To avoid SPAM, keep this secure. Do not put this code on public webpages'
                  : language.signupform.add.linkToForm}
              </h3>
              <input
                style={{
                  // width: 450,
                  height: 35,
                  marginRight: 15,
                  // maxWidth: '100%',
                  width: 'calc(100% - 133px)',
                  borderRadius: 35,
                }}
                type="text"
                disabled={true}
                value={url}
              />
              <CopyToClipboard
                onCopy={() =>
                  this.setState({
                    ...this.state,
                    copied: true,
                    open: true,
                    anchorEl: null,
                  })
                }
                text={url}
              >
                <Button
                  size={'large'}
                  variant="contained"
                  color="secondary"
                  style={{ marginTop: 10 }}
                >
                  <FileCopy style={{ marginRight: 5 }} />
                  Copy
                </Button>
              </CopyToClipboard>
              {this.props.internal_type !== 'ci1' && (
                <p style={{ width: '100%', maxWidth: 580, fontSize: 12 }}>
                  <em>
                    {language.signupform.add.byoReCaptcha}{' '}
                    <strong>{FORM_URL.replace('https://', '')}</strong>{' '}
                    {language.signupform.add.byoReCaptcha2}{' '}
                    <a
                      rel="noopener noreferrer"
                      href="https://developers.google.com/recaptcha/docs/settings"
                      target="_blank"
                    >
                      {language.signupform.add.byoReCaptcha3}{' '}
                    </a>{' '}
                  </em>
                </p>
              )}
              {this.props.internal_type === 'ci1' && (
                <div style={{ marginTop: 10 }}>
                  <h3 style={{ marginBottom: 0 }}>Sample requests</h3>
                  <div style={{ marginBottom: 5 }}>
                    You can use the code below to make a POST request with some
                    sample data to your custom integration
                  </div>
                  <Hidden mdUp>
                    <AppBar position="static" color="default">
                      <Tabs
                        value={this.state.tabValue}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        centered
                      >
                        <Tab label="NodeJS" />
                        <Tab label="Python" />
                        <Tab label="cURL" />
                        <Tab label="PHP" />
                      </Tabs>
                    </AppBar>
                  </Hidden>
                  <Hidden smDown>
                    <AppBar position="static" color="default">
                      <Tabs
                        value={this.state.tabValue}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                      >
                        <Tab label="NodeJS" />
                        <Tab label="Python" />
                        <Tab label="cURL" />
                        <Tab label="PHP" />
                      </Tabs>
                    </AppBar>
                  </Hidden>
                  <div style={{ marginTop: 10 }}>
                    <AceEditor
                      readOnly
                      width="100%"
                      mode={modeArr?.[this.state.tabValue]}
                      theme="monokai"
                      name="blah2"
                      fontSize={12}
                      showPrintMargin={true}
                      wrapEnabled={true}
                      showGutter={true}
                      highlightActiveLine={true}
                      value={pretty(codeArr?.[this.state.tabValue] || '')}
                      setOptions={{
                        showLineNumbers: true,
                        tabSize: 2,
                      }}
                      debounceChangePeriod={1500}
                      height="350px"
                    />
                  </div>
                </div>
              )}
            </div>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              open={this.state.copied}
              autoHideDuration={2000}
              onClose={this.handleClose}
              ContentProps={{
                'aria-describedby': 'message-id',
              }}
              message={
                <span id="message-id">
                  {language.signupform.add.copyClipboard}
                </span>
              }
            />
          </div>
        )
			}
		},
	),
)
